<div class="add-vendor-poc-container">
  <div class="popup-header">
    <h2 class="popup-title">{{ ACCESS_CONTROL_TEXT.ADD_VENDOR_TITLE }}</h2>
    <button class="close-dialog-btn" type="button" (click)="onCancel()" aria-label="Close">
      <emerald-icon icon="close"></emerald-icon>
    </button>
    <p class="popup-subtitle">
      {{ ACCESS_CONTROL_TEXT.ADD_VENDOR_SUBTITLE }}
    </p>
  </div>
  <form [formGroup]="vendorPocForm">
    <div class="form-grid">
      <div class="form-cell">
        <label for="vendorName">{{ ACCESS_CONTROL_TEXT.VENDOR_NAME }}<span style="color:red">*</span></label>
        <emerald-dropdown class="vendor-poc-field" id="vendorName" [options]="vendorOptions"
          formControlName="vendorName" [outlined]="true"></emerald-dropdown>
        <div *ngIf="vendorPocForm.get('vendorName')?.invalid && vendorPocForm.get('vendorName')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.VENDOR_NAME }} {{ ACCESS_CONTROL_TEXT.REQUIRED }}</div>
      </div>
      <div class="form-cell">
        <label for="vendorRep">{{ ACCESS_CONTROL_TEXT.VENDOR_REP_LABEL }}<span style="color:red">*</span></label>
        <emerald-input class="vendor-poc-field" id="vendorRep" formControlName="vendorRep" label=""
          [outlined]="true"></emerald-input>
        <div *ngIf="vendorPocForm.get('vendorRep')?.invalid && vendorPocForm.get('vendorRep')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.VENDOR_REP_LABEL }} {{ ACCESS_CONTROL_TEXT.REQUIRED }}</div>
      </div>
    </div>

    <div class="form-grid">
      <div class="form-cell">
        <label for="email">{{ ACCESS_CONTROL_TEXT.EMAIL }}<span style="color:red">*</span></label>
        <emerald-input class="vendor-poc-field" id="email" formControlName="email" [outlined]="true"></emerald-input>
        <div *ngIf="vendorPocForm.get('email')?.hasError('required') && vendorPocForm.get('email')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.EMAIL }} {{ ACCESS_CONTROL_TEXT.REQUIRED }}</div>
        <div *ngIf="vendorPocForm.get('email')?.hasError('email') && vendorPocForm.get('email')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.INVALID_EMAIL }}</div>
        <div *ngIf="vendorPocForm.get('email')?.hasError('emailTaken') && vendorPocForm.get('email')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.EMAIL_EXISTS }}</div>
      </div>
      <div class="form-cell">
        <label for="contact">{{ ACCESS_CONTROL_TEXT.CONTACT }}<span style="color:red">*</span></label>
        <emerald-input class="vendor-poc-field" id="contact" formControlName="contact"
          [outlined]="true"></emerald-input>
        <div *ngIf="vendorPocForm.get('contact')?.hasError('required') && vendorPocForm.get('contact')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.CONTACT }} {{ ACCESS_CONTROL_TEXT.REQUIRED }}</div>
        <div *ngIf="vendorPocForm.get('contact')?.hasError('pattern') && vendorPocForm.get('contact')?.touched"
          class="error-message">{{ ACCESS_CONTROL_TEXT.CONTACT_NUMERIC }}</div>
      </div>
    </div>

    <div class="form-grid vendor-access-row">
      <div class="form-cell vendor-access-cell">
        <label>{{ ACCESS_CONTROL_TEXT.VENDOR_ACCESS_LABEL }}</label>
        <emerald-switch formControlName="vendorAccess"></emerald-switch>
        <span>{{ vendorPocForm.get("vendorAccess")?.value ? ACCESS_CONTROL_TEXT.YES : ACCESS_CONTROL_TEXT.NO }}</span>
      </div>
      <!-- Vendor persona: opt the contact into the view-only iSkill Team Explorer.
           Only meaningful together with Vendor Access; saved as false otherwise. -->
      <div class="form-cell vendor-access-cell">
        <label>{{ ACCESS_CONTROL_TEXT.ISKILL_ACCESS_LABEL }}</label>
        <emerald-switch formControlName="iskillAccess"></emerald-switch>
        <span>{{ vendorPocForm.get("iskillAccess")?.value ? ACCESS_CONTROL_TEXT.YES : ACCESS_CONTROL_TEXT.NO }}</span>
      </div>
    </div>
  </form>

  <div class="form-actions">
    <emerald-button type="Secondary" [label]="ACCESS_CONTROL_TEXT.CANCEL" (onClick)="onCancel()"></emerald-button>
    <emerald-button type="Primary" [label]="ACCESS_CONTROL_TEXT.SUBMIT" class="vendor-poc-submit-btn" (onClick)="onSubmit()"></emerald-button>
  </div>
</div>